import React from 'react';
import TaskSingleView from '../TaskSingleView';
import StageActionButton from '../../../components/partials/StageActionButton';
import { checkTranslation, chooseWallpaper, conditionalWidth, imageAddress, playSound, translate } from "../../../utils/useful";
import Responsive from '../../../components/Responsive';
import moment from "moment";
import HttpServices from '../../../utils/Http.services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import Collapsible from "react-collapsible";
import AddSubtaskSidePanel from '../Eagleviews/addSubtaskSidePanel';
class Subtasks extends React.Component {


    nextStage = (cb) => {
        // this.setState({ isLoading: true, errors: {} })
        if (this.form) {
            let data = this.form.getForm()
            if (data) {
                this.props.setData(data, () => {
                    // this.props.postUserInfo((result, err) => {
                    // if (err) { this.setState({ errors: err }) }
                    // this.setState({ isLoading: false })
                    this.props.chooseNextPage()

                    // })
                })
            }
        }
    }
    getSubtask = (currentItem, cb) => {
        let showSubTasks = this.state.showSubTasks
        for (let i = 0; i < this.props.inbox.desk.length; i++) {
            for (let z = 0; z < this.props.inbox.desk[i].parent.length; z++) {
                console.log(this.props.inbox.desk[i].parent[z]._id)
                if (this.props.inbox.desk[i].parent[z]._id == currentItem._id) {
                    console.log(true)
                    showSubTasks.push(this.props.inbox.desk[i])
                }

            }
        }
        this.setState({ showSubTasks }, () => {
            console.log('sub task', showSubTasks)
            if (cb)
                cb()
            // this.subTaskSidebar.openSidebar()
            // this.subTaskStageManager.changeStage('showSubTask')
        })
    }
    constructor(props) {
        super(props)


        this.state = {
            showSubTasks: [],
            showSubtasks: false,
            addSubtasks: {},
            showMonthList: false,
            showYearList: false,
            showConfirmation: false,
            isOpen: { 0: true, 1: true, 2: true },
            Day: false,
            showPriorityCollapse: false,
            showTimeCollapse: true,
            showPercentCollapse: false,
            showGroupby: false,
            dateObject: moment(),
            tasks: [],
            chartOption: {
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false
            },
            data: {
                labels: ['Done', "Not Done"],
                datasets: [{
                    data: [1, 2],
                    backgroundColor: ['#ee5050', '#007aff']
                }]
            },
            collapsible: [
                { name: "Today" },


            ],
            currentTab: 0,

        }
    }
    componentDidMount() {

        console.log('here', this.props.showSubTasks)
        this.getSubtask(this.props.data)


        this.setState({ title: this.props.title, today: new Date().getTime() })
        setTimeout(() => {
        }, 100);

        if (this.props.title) {
            this.setMonth(0, this.props.title)

        } else {
            this.setMonth(0)
        }

        let filter = {
        }
        window.addEventListener("keydown", this.keyPress)
    }





    setMonth(fromNow, startDate) {


        let now = new Date();
        let days = []

        let start = moment(now).startOf('month').add(fromNow, 'month').startOf('month')

        if (startDate) {
            start = moment(startDate).add(fromNow, 'month').startOf('month')

        }


        console.log(moment(now).add(fromNow, 'month').daysInMonth())

        for (let i = 0; i < moment(now).add(fromNow, 'month').daysInMonth(); i++) {

            days.push({ start: moment(start).add(i, 'day').startOf('day').valueOf(), end: moment(start).add(i, 'day').endOf('day').valueOf() })

        }

        let newDate = [Number(moment(start).format('YYYY')), moment(start).format('M') - 1, 1]

        this.setState({ month: { title: moment(start).format('YYYY-MMMM'), month: moment(start).format('MMMM'), monthNumber: moment(start).format('M') - 1, year: Number(moment(start).format('YYYY')), startDay: start.day(), days: days } }, () => {


        })

    }

    setDay(day, dayNumber) {

        this.setState({ title: day.start })
        this.props.onChange(this.props.headerkey, { type: 'changeDay', newDay: day.start, dayNumber })

    }
    changeWeek() {
        this.setState({ startDay: this.state.month.startDay })

    }
    showDays() {
        let week = []
        let weeks = []
        let days = []
        let startDay = this.state.month.startDay
        let count = 0

        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }
        if (!this.state.month.days) {
            return
        }
        days = [...days, ...this.state.month.days]
        console.log(this.state.month.days);

        for (let i = 0; i < days.length; i++) {
            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }
        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {

                weeks[weeks.length - 1].push(null)
            }
        }
        count = 0
        return (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }} className="Weeks">
                {weeks.map((week, index) => {
                    return (

                        <div key={index} className="d-flex text-center pld-2 prd-2 w-100" style={{ justifyContent: 'space-between', flexDirection: "row" }}>
                            {week.map((day, index1) => {

                                if (day == null) {
                                    return (
                                        <div key={index1} style={{ textTransform: 'uppercase', width: '100%', margin: -1, border: '1px solid transparent' }}>
                                        </div>
                                    )
                                } else {
                                    count++
                                    let dayNumber = count

                                    let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                                    let selectedDay = (this.state.title >= day.start && this.state.title <= day.end) ? true : false
                                    return (
                                        <div onClick={() => this.setDay(day, dayNumber)} key={index1} style={{ overflow: 'hidden', cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#e2e8ea' : '#fcfcfc', padding: 0, borderRadius: " 50%", width: "100%", minHeight: 80, justifyContent: 'center', alignItems: 'center', display: 'flex', border: '1px solid #eee', margin: -1 }}>
                                            <div style={{ backgroundColor: isToday ? '#00206010' : 'transparent', borderRadius: "50%", padding: "10px 10px", width: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                                <p style={{ color: selectedDay ? '#789' : '#789', fontSize: 12, fontWeight: 'bold' }}>{count}</p>
                                                {/* {count % 2 == 0 && ( */}
                                                <div className="flexcc w-100 flex-column">
                                                    {this.props.data && Array.isArray(this.props.data[count]) && (
                                                        <div className="w-100 text-center" style={{ overflow: 'hidden', backgroundColor: '#42BECA', padding: '5px 5px', borderRadius: 4, marginTop: 3 }}>
                                                            <p style={{ fontSize: 11, color: '#fff', }}>{this.props.data[count].length}{this.state.width > 550 ? " EVENTS" : ''}</p>
                                                            {/* <p style={{ fontSize: 11, color: '#101010', }}>{"RO-123"}</p> */}
                                                        </div>
                                                    )}

                                                    {this.state.width > 550 && (!this.props.data || !Array.isArray(this.props.data[count]) || this.props.data[count].length == 0) && (
                                                        <p className='mt-2' style={{ fontSize: 12, color: '#bcd' }}>NO DATA</p>
                                                    )}
                                                </div>
                                                {/* )} */}
                                            </div>
                                        </div>
                                    )
                                }
                            })
                            }

                        </div>

                    )
                })
                }
            </div>)
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.keyPress)
    }

    changeTab = (prop, index) => {
        this.setState({ currentTab: index })
    }

    keyPress = (e) => {
        if ((e.ctrlKey || e.metaKey) && e?.key == 'n') {
            this.addClicked()
            // this.hideModal()
        }
    }
    changePage = (item) => {
        this.setState({ currentPage: item.key })
    }
    postTask = (data, cb) => {
        console.log('body', data);
        let body = data

        HttpServices.request('addTask', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            console.log(fetchError)
            console.log(fetchResult)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                cb(null, fetchError)
                return
            }
            playSound('newMessage')
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
            cb(fetchResult.info)
        })

    }
    changeTaskStage = (_id, stage, cb) => {

        let body = { _id, stage }

        HttpServices.request('changeTaskStage', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                cb(null, fetchError)
                return
            }
            playSound('newMessage')
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
            cb(fetchResult.info)
        })

    }
    showInfo = (item) => {
        let data = item

        this.setState({ currentData: data, sideOpen: true, showConfig: false }, () => {
            this.setState({ showConfig: true })
        })

        // this.addModal.showModal()
    }
    closeSidebar = () => {
        this.setState({ sideOpen: false })
    }

    addClicked = (open) => {
        this.addTaskModal.modal.showModal()
    }
    chengecollaps = (index) => {
        let isOpen = this.state.isOpen

        // console.log('isOpennnnnnnnnnnnnn', isOpen)
        isOpen[index] = this.state.isOpen[index] == null ? true : !this.state.isOpen[index]
        this.setState({ isOpen })

    }
    showRequests = () => {
        this.setState({ showConfirmation: !this.state.showConfirmation })
        console.log(this.state.showConfirmation, "showconfirmation")
    }

    addSubtask = (menuList) => {
        console.log('here', menuList)
        let addSubtasks = this.state.addSubtasks
        if (!addSubtasks[menuList]) {
            addSubtasks[menuList] = true
        }
        addSubtasks[menuList] = true
        this.setState({ addSubtasks })
    }

    render() {
        return (
            <div className="scroll-no-scrollbar h-100 modal-body  " style={{ borderRadius: '0px 8px 8px 0px' }}>

                <div className="window-content-radius w-100 h-100 " style={{ backgroundColor: 'white' }}>

                    <div className='d-flex w-100 h-100'>
                        <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '12', md: '8', lg: "9", xl: "9" }}>
                            <div className=' w-100'>


                                {this.state.collapsible.map((item, index) => {
                                    return (
                                        <div className='w-100' key={index}>
                                            <div className={this.state.isOpen[index] ? 'leftsideItems' : ''} style={{ transition: "all 0.5s", paddingBottom: '0.1rem' }}>
                                                {/* <div onClick={() => { this.chengecollaps(index) }} className='flexc w-100 py-1 px-3 cursor-pointer groupby-btn' style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}
                                                        >

                                                             <div className='d-flex flex-column mld-3' style={{ width: "37px" }}>
                                                                <p className='text-bold text-smaller' style={{ color: "#4F5B67" }}>{translate(item.name)}</p>

                                                            </div> 
                                                            <img src='/assets/icons/applets/desk/control.svg' style={{ transform: "rotate(-180deg)", opacity: "80%", width: "9px", marginLeft: ".5rem" }} />

                                                        </div> */}
                                                <Collapsible open={this.state.isOpen[index]} >

                                                    {/* <div style={{ height:'20px',width:'20px',border:'2px solid black',borderRadius:'20px'}}>
                                                        back
                                                    </div> */}
                                                    <div className='w-100' key={index}>
                                                        <div className='px-3 flexc pt-3 '>
                                                            <img src='/assets/icons/applets/desk/previous.png' width={'25px'} className='mrd-2' style={{ cursor: 'pointer' }} onClick={() => this.props.changeStage('taskView')} />
                                                            <div className='' style={{ flex: 1 }}>
                                                                {console.log('title data', this.props.data)}
                                                                <p className='text-semibold text-semibig mt-0'>{checkTranslation(this.props.data?.title)}</p>

                                                            </div>

                                                            <div className='py-1 px-2  task-priority' style={{ backgroundColor: '#FEE9EE', color: '#CA5C72', borderRadius: 4 }}>
                                                                <p className=' text-smallest text-semibold'>{translate('desk.TO DO')}</p>
                                                            </div>

                                                        </div>
                                                        <div className='flexc pb-2 ' style={{ paddingLeft: '3rem' }}>
                                                            <img className='task-check-img' src={imageAddress(this.state.current?.user?.image, 'profile')} height={14} width={14} style={{ borderRadius: 20 }} />
                                                            <p className='task-applet-name text-smaller color-gray-2  cursor-pointer mx-1 text-semibold'>Elitive {translate('desk. Tasks Applet')}</p>
                                                        </div>
                                                        {this.state.showSubTasks.map((item, index) => {
                                                            console.log('show sub tasks', this.state.showSubTasks)
                                                            return (
                                                                <div className={'w-100 task-row' + (item.done ? ' done ' : '')} key={index}>
                                                                    <div className='d-flex w-100 py-2  ' style={{ borderBottom: '1px solid #EFF0F1', padding: "0rem 1rem" }}>
                                                                        <StageActionButton />
                                                                        <div className='flexc task-info w-100'>
                                                                            <div className='d-flex flex-column mld-3 flex-1'>
                                                                                <p onClick={() => this.props.showInfo(item)} className='task-title  text-small color-gray-3 cursor-pointer'>{checkTranslation(item.title)}</p>

                                                                                <div className='flexc'>
                                                                                    <p className='task-applet-name text-smaller color-gray-2  cursor-pointer mt-1 '>{translate('desk.Elitive - Tasks |  Seen | 12:10')}</p>
                                                                                </div>

                                                                            </div>
                                                                            {/* <div className='position-relative flexc ' style={{ backgroundColor: '#ee5050', height: 10, width: 100, borderRadius: 4, overflow: 'hidden', right: "3%" }}>
                                                                                <div className=' h-100' style={{ width: '73%', left: 0, backgroundColor: 'rgb(0, 205, 116)' }}>
                                                                                </div>
                                                                                <div className=' h-100' style={{ width: '10%', left: 0, backgroundColor: 'rgb(255, 197, 0)' }}>
                                                                                </div>

                                                                            </div> */}
                                                                            <div className='mx-2'>
                                                                                <div className='py-1 px-2  task-priority' style={{ backgroundColor: '#FEE9EE', color: '#CA5C72', borderRadius: 4 }}>
                                                                                    <p className=' text-smallest'>{translate('desk.High')}</p>
                                                                                </div>
                                                                            </div>

                                                                            <div className='mx-2'>
                                                                                <img className='task-check-img' src={imageAddress(item?.user?.image, 'profile')} height={20} width={20} style={{ borderRadius: 20 }} />
                                                                            </div>
                                                                        </div>


                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </Collapsible>
                                            </div>
                                        </div>
                                    )
                                })}


                            </div>
                        </Responsive>
                    </div>

                    {/* <div onClick={() => { this.closeSidebar() }} className={'position-fixed top-0 left-0 w-100 h-100 fadein ' + (this.state.sideOpen ? '' : 'd-none')} style={{ zIndex: 10, backgroundColor: '#10101040' }}>
                    </div>

                    <div className={"sidePanel h-100  " + (conditionalWidth(this.props.width, { xs: '' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ zIndex: 20, maxWidth: 400, width: conditionalWidth(this.props.width, { xs: '90%', md: '80%', }) }} >
                        <div className='sidePanel-content h-100 blur-back' >
                            {this.state.showConfig && (
                                // <TaskSingleView data={this.state.currentData} showSubtask={() => this.setState({ showSubtasks: !this.state.showSubtasks }, console.log(this.state.showSubtasks))} />
                                <TaskSingleView data={this.state.currentData}
                                    showSubtask={() => this.setState({ showSubtasks: !this.state.showSubtasks }, console.log(this.state.showSubtasks))}
                                    addSubtask={this.addSubtask}
                                />
                            )}

                            <button className={"close-hide sideHandler blur-back flexcc "} onClick={e => this.closeSidebar()}>
                                <img src="/images/next-2.png" width="20px" alt="" />
                            </button>
                        </div>
                    </div>
                    {this.state.showSubtasks ?
                        <div className={"sidePanel h-100  " + (conditionalWidth(this.props.width, { xs: '' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ zIndex: 21, maxWidth: 400, width: conditionalWidth(this.props.width, { xs: '90%', md: '80%', }) }} >
                            <div className='sidePanel-content h-100 blur-back' >

                                <Subtasks />


                                <button className={"close-hide sideHandler blur-back flexcc "} onClick={() => this.setState({ showSubtasks: false })}>
                                    <img src="/images/next-2.png" width="20px" alt="" />
                                </button>
                            </div>
                        </div>
                        : null}
                    {this.state.addSubtasks['Add Subtasks'] ?
                        <div className={"sidePanel h-100  " + (conditionalWidth(this.props.width, { xs: '' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ zIndex: 21, maxWidth: 400, width: conditionalWidth(this.props.width, { xs: '90%', md: '80%', }) }} >
                            <div className='sidePanel-content h-100 blur-back' >

                                <AddSubtaskSidePanel ref={el => this.addTaskModal = el} postTask={this.postTask} />


                                <button className={"close-hide sideHandler blur-back flexcc "} onClick={() => this.setState({ addSubtasks: false })}>
                                    <img src="/images/next-2.png" width="20px" alt="" />
                                </button>
                            </div>
                        </div>
                        : null} */}

                </div >
            </div >

        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Subtasks);
